export const GET_PAST_LAUNCHES_INIT = 'GET_PAST_LAUNCHES_INIT';
export const GET_PAST_LAUNCHES_SUCCESS = 'GET_PAST_LAUNCHES_SUCCESS';
export const GET_PAST_LAUNCHES_FAILURE = 'GET_PAST_LAUNCHES_FAILURE';

export const GET_UPCOMING_LAUNCHES_INIT = 'GET_UPCOMING_LAUNCHES_INIT';
export const GET_UPCOMING_LAUNCHES_SUCCESS = 'GET_UPCOMING_LAUNCHES_SUCCESS';
export const GET_UPCOMING_LAUNCHES_FAILURE = 'GET_UPCOMING_LAUNCHES_FAILURE';



// WEBPACK FOOTER //
// ./src/constants/LaunchTypes.js